import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { DocumentRule, IDocumentRule } from "@/models/document-rule.entity";
import { MrfiktivDocumentRuleControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Module, getModule } from "vuex-module-decorators";
import { PaginatedBaseStore } from "../paginated-base.store";
import { DocumentRuleDataAccessLayer } from "./access-layers/document-rule.access-layer";
import { PaginationFilterListElement } from "./base-pagination.store";
import { DocumentRulePageDataProvider } from "./page-data-provider/document-rule.page-data-provider";

@Module({
  dynamic: true,
  namespaced: true,
  name: "document-rule",
  store
})
export class DocumentRulePaginationStore extends PaginatedBaseStore<
  IDocumentRule,
  MrfiktivDocumentRuleControllerGetParamsGen
> {
  protected _data = DocumentRuleDataAccessLayer;
  protected _pageProvider = DocumentRulePageDataProvider;
  protected _pager = new PageDataHandler(this._data, this._pageProvider);

  filterOptions: PaginationFilterListElement[] = DocumentRule.filterables;

  /**
   * The `rule` property is stored as long markdown text. Tell Fuse to match the
   * search term anywhere within a field so rules can be found by their content,
   * not just by text near the beginning of the value.
   */
  fuseSearchOptions = { ignoreLocation: true };
}

export const DocumentRuleModule = getModule(DocumentRulePaginationStore);
